export default __webpack_public_path__ + "static/media/abtpg.35a9fb95.png";